import { RotateCcw } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { cn } from "@/lib/utils";

/**
 * @param {object} props
 * @param {boolean} props.open
 * @param {(open: boolean) => void} props.onOpenChange
 * @param {() => void | Promise<void>} props.onConfirmYes
 */
export function FlowSessionResetDialog({ open, onOpenChange, onConfirmYes }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className={cn(
          "gap-0 overflow-hidden p-0 sm:max-w-md",
          "border-border/80 shadow-lg",
        )}
      >
        <div className="border-b border-border/60 bg-muted/30 px-6 pb-4 pt-6">
          <DialogHeader className="space-y-4 text-left">
            <div
              className="flex h-12 w-12 items-center justify-center rounded-2xl bg-amber-500/15 text-amber-600 ring-1 ring-amber-500/20 dark:bg-amber-400/10 dark:text-amber-300 dark:ring-amber-400/25"
              aria-hidden
            >
              <RotateCcw className="h-6 w-6" strokeWidth={2.25} />
            </div>
            <div className="space-y-1.5">
              <DialogTitle className="text-xl font-semibold tracking-tight">Reset flow session?</DialogTitle>
              <DialogDescription className="text-[15px] leading-relaxed text-muted-foreground">
                This clears triage and bot state for this thread. Your message history is not deleted.
              </DialogDescription>
            </div>
          </DialogHeader>
        </div>
        <DialogFooter className="flex flex-row items-center justify-end gap-2 border-t border-border/60 bg-background px-6 py-4 sm:justify-end">
          <Button type="button" variant="outline" className="min-w-18" onClick={() => onOpenChange(false)}>
            No
          </Button>
          <Button
            type="button"
            className="min-w-18"
            onClick={() => {
              void onConfirmYes();
            }}
          >
            Yes
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
